import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
type ModalType = 'privacy' | 'terms' | null;
function CloseIcon({
  className
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-76">
      <line x1="18" y1="6" x2="6" y2="18" data-id="element-77" />
      <line x1="6" y1="6" x2="18" y2="18" data-id="element-78" />
    </svg>;
}
const privacyContent = <div className="space-y-6 text-dark/80 text-sm leading-relaxed" data-id="element-79">
    <h2 className="text-2xl font-serif font-bold text-dark" data-id="element-80">
      Política de Privacidad
    </h2>
    <p className="text-dark/50 text-xs" data-id="element-81">Última actualización: Marzo 2026</p>

    <section className="space-y-3" data-id="element-82">
      <h3 className="font-bold text-dark text-base" data-id="element-83">
        1. Información que Recopilamos
      </h3>
      <p data-id="element-84">
        Recopilamos únicamente la información necesaria para procesar tu compra
        y entregarte el producto digital. Esto incluye: nombre, dirección de
        correo electrónico y datos de pago (procesados de forma segura por
        nuestro proveedor de pagos externo).
      </p>
    </section>

    <section className="space-y-3" data-id="element-85">
      <h3 className="font-bold text-dark text-base" data-id="element-86">
        2. Uso de la Información
      </h3>
      <p data-id="element-87">Tu información personal se utiliza exclusivamente para:</p>
      <ul className="list-disc pl-5 space-y-1" data-id="element-88">
        <li data-id="element-89">Procesar y confirmar tu compra</li>
        <li data-id="element-90">Enviarte el acceso al producto digital</li>
        <li data-id="element-91">
          Comunicarnos contigo respecto a tu pedido o solicitud de garantía
        </li>
      </ul>
    </section>

    <section className="space-y-3" data-id="element-92">
      <h3 className="font-bold text-dark text-base" data-id="element-93">3. Protección de Datos</h3>
      <p data-id="element-94">
        No vendemos, alquilamos ni compartimos tu información personal con
        terceros con fines comerciales. Implementamos medidas de seguridad
        estándar de la industria para proteger tus datos.
      </p>
    </section>

    <section className="space-y-3" data-id="element-95">
      <h3 className="font-bold text-dark text-base" data-id="element-96">4. Cookies</h3>
      <p data-id="element-97">
        Nuestro sitio puede utilizar cookies esenciales para el funcionamiento
        del sitio y cookies analíticas para mejorar tu experiencia. Puedes
        desactivar las cookies en la configuración de tu navegador.
      </p>
    </section>

    <section className="space-y-3" data-id="element-98">
      <h3 className="font-bold text-dark text-base" data-id="element-99">5. Tus Derechos</h3>
      <p data-id="element-100">
        Tienes derecho a acceder, rectificar o eliminar tus datos personales en
        cualquier momento. Para ejercer estos derechos, contáctanos a través de
        nuestro correo electrónico de soporte.
      </p>
    </section>

    <section className="space-y-3" data-id="element-101">
      <h3 className="font-bold text-dark text-base" data-id="element-102">
        6. Cambios en esta Política
      </h3>
      <p data-id="element-103">
        Nos reservamos el derecho de actualizar esta política de privacidad.
        Cualquier cambio será publicado en esta página con la fecha de
        actualización correspondiente.
      </p>
    </section>
  </div>;
const termsContent = <div className="space-y-6 text-dark/80 text-sm leading-relaxed" data-id="element-104">
    <h2 className="text-2xl font-serif font-bold text-dark" data-id="element-105">
      Términos y Condiciones
    </h2>
    <p className="text-dark/50 text-xs" data-id="element-106">Última actualización: Marzo 2026</p>

    <section className="space-y-3" data-id="element-107">
      <h3 className="font-bold text-dark text-base" data-id="element-108">1. Producto Digital</h3>
      <p data-id="element-109">
        Intimidad Radical es un producto digital en formato PDF. Al completar tu
        compra, recibirás acceso inmediato y permanente al contenido. Este es un
        pago único sin cargos recurrentes ni suscripciones.
      </p>
    </section>

    <section className="space-y-3" data-id="element-110">
      <h3 className="font-bold text-dark text-base" data-id="element-111">2. Licencia de Uso</h3>
      <p data-id="element-112">
        Al adquirir este producto, se te otorga una licencia personal e
        intransferible para uso individual. Queda estrictamente prohibido:
      </p>
      <ul className="list-disc pl-5 space-y-1" data-id="element-113">
        <li data-id="element-114">Reproducir, distribuir o compartir el contenido con terceros</li>
        <li data-id="element-115">Revender o sublicenciar el producto</li>
        <li data-id="element-116">Modificar el contenido para su redistribución</li>
      </ul>
    </section>

    <section className="space-y-3" data-id="element-117">
      <h3 className="font-bold text-dark text-base" data-id="element-118">
        3. Garantía de Devolución
      </h3>
      <p data-id="element-119">
        Ofrecemos una garantía de satisfacción de 7 días a partir de la fecha de
        compra. Si no estás satisfecho con el producto, puedes solicitar un
        reembolso completo dentro de este período sin necesidad de
        justificación. Para solicitar tu reembolso, simplemente envíanos un
        correo electrónico.
      </p>
    </section>

    <section className="space-y-3" data-id="element-120">
      <h3 className="font-bold text-dark text-base" data-id="element-121">4. Resultados</h3>
      <p data-id="element-122">
        Los testimonios y resultados mencionados en esta página representan
        experiencias individuales. Los resultados pueden variar de persona a
        persona. Este producto no sustituye asesoramiento profesional de salud
        mental o consejería pastoral.
      </p>
    </section>

    <section className="space-y-3" data-id="element-123">
      <h3 className="font-bold text-dark text-base" data-id="element-124">
        5. Propiedad Intelectual
      </h3>
      <p data-id="element-125">
        Todo el contenido de Intimidad Radical, incluyendo textos, diseños y
        metodologías, está protegido por derechos de autor. Cualquier uso no
        autorizado será perseguido conforme a la ley aplicable.
      </p>
    </section>

    <section className="space-y-3" data-id="element-126">
      <h3 className="font-bold text-dark text-base" data-id="element-127">6. Modificaciones</h3>
      <p data-id="element-128">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Los cambios no afectarán las compras ya realizadas.
      </p>
    </section>
  </div>;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-dark border-t border-white/5 py-8 px-4" data-id="element-129">
        <div className="max-w-4xl mx-auto flex flex-col items-center gap-4" data-id="element-130">
          <div className="flex items-center gap-6" data-id="element-131">
            <button onClick={() => setActiveModal('privacy')} className="text-cream/40 hover:text-gold text-sm tracking-wide transition-colors" data-id="element-132">
              Política de Privacidad
            </button>
            <span className="w-1 h-1 rounded-full bg-gold/30" data-id="element-133" />
            <button onClick={() => setActiveModal('terms')} className="text-cream/40 hover:text-gold text-sm tracking-wide transition-colors" data-id="element-134">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-cream/20 text-xs tracking-wider" data-id="element-135">
            © {new Date().getFullYear()} Intimidad Radical. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-136">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-137">
            <motion.div initial={{
          opacity: 0,
          y: 20,
          scale: 0.97
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 20,
          scale: 0.97
        }} transition={{
          duration: 0.3
        }} className="bg-cream rounded-xl shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-138">
              <div className="flex items-center justify-between p-5 border-b border-dark/10" data-id="element-139">
                <span className="text-xs font-bold uppercase tracking-widest text-dark/40" data-id="element-140">
                  {activeModal === 'privacy' ? 'Privacidad' : 'Términos'}
                </span>
                <button onClick={() => setActiveModal(null)} className="text-dark/40 hover:text-dark transition-colors p-1" data-id="element-141">
                  <CloseIcon className="w-5 h-5" data-id="element-142" />
                </button>
              </div>
              <div className="overflow-y-auto p-6 md:p-8" data-id="element-143">
                {activeModal === 'privacy' ? privacyContent : termsContent}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}